import { render, staticRenderFns } from "./WeeklyWorkload.vue?vue&type=template&id=f8c1ec94"
import script from "./WeeklyWorkload.vue?vue&type=script&lang=js"
export * from "./WeeklyWorkload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports